import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { C8StaticDatumsEdit } from "./edit";
import { C8StaticDataNew } from "./new";
import { C8StaticDatumsTable } from "./table";
export default function C8StaticDatums() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Actifs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<C8StaticDatumsEdit />} />
      <Route index element={<C8StaticDatumsTable />} />
      <Route path="/new" element={<C8StaticDataNew />} />
    </Routes>
  );
}
